module.exports = __webpack_public_path__ + "img/Man-4.cf437d31.svg";